'use es6';

import { getAvailableTrials } from 'self-service-api/api/getAvailableTrials';
import ActionTypes from '../constants/ActionTypes';
export var fetchTrialState = function fetchTrialState() {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.TRIAL_STATE_REQUESTED
    });
    getAvailableTrials().then(function (trialState) {
      dispatch({
        type: ActionTypes.TRIAL_STATE_RECEIVED,
        payload: trialState
      });
    }).catch(function () {
      dispatch({
        type: ActionTypes.TRIAL_STATE_FAILED
      });
    });
  };
};